module.exports = [
  {
    url: '/role/all',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          {
            role_id: '828757906454216704',
            name: '管理员',
            code: 'admin',
            status: 1,
            remark: '运维角色',
            create_time: '2024-01-29 21:52:54',
            update_time: '2024-01-29 21:52:54',
            deleted: 0,
          },
          {
            role_id: '22222',
            name: '麦当劳',
            code: 'root',
            status: 1,
            remark: '餐饮角色',
            create_time: '2024-01-29 21:52:54',
            update_time: '2024-01-29 21:52:54',
            deleted: 0,
          },
        ],
      }
    },
  },
  {
    url: '/role/save',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/role/update',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/role/delete',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
  {
    url: '/role/permission/bind',
    type: 'post',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: '',
      }
    },
  },
]
